import * as firebase from 'firebase';
// const firebase = require('firebase');
require('firebase/firestore');
require('firebase/functions');

var config = {
	apiKey: 'AIzaSyDq9EzLk9uJvnvYZuHfWs0mpUo9JNC-ubA',
	authDomain: 'talent-7d36f.firebaseapp.com',
	databaseURL: 'https://talent-7d36f.firebaseio.com',
	projectId: 'talent-7d36f',
	storageBucket: 'talent-7d36f.appspot.com',
	messagingSenderId: '982201680088'
};
firebase.initializeApp(config);

export default firebase;

// export const auth = firebase.auth();
// export const firestore = firebase.firestore();



// WEBPACK FOOTER //
// ./src/helper/firebase.js